import { defineMessages } from 'react-intl';

export default defineMessages({
  provided: {
    id: 'fastCover.DocumentTable.provided',
    defaultMessage: 'Documents Provided',
  },
  currency: {
    id: 'fastCover.DocumentTable.currency',
    defaultMessage: 'Currency',
  },
  Benefit: {
    id: 'fastCover.DocumentTable.Benefit',
    defaultMessage: 'Benefit',
  },
  Description: {
    id: 'fastCover.DocumentTable.Description',
    defaultMessage: 'Description',
  },
  Amount: {
    id: 'fastCover.DocumentTable.Amount',
    defaultMessage: 'Amount Claimed',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/DocumentTable/messages.js